import React, { Component, Fragment } from 'react';
import Timer from './timer';
import PropTypes from 'prop-types';
import Confirmation from './../commonComponents/confirmationBox';
import HelpMenu from './helpMenu';
import HelpContainer from './helpContainer';
import SimLogo from './../UiComponents/Logo';
import getLabel from './../../utils/labels'
import downArrow from './../../globals/images/down-arrow.svg';
import headerImage from './../../globals/images/header.png';
import helpIcon from './../../globals/images/help.svg';
import styles from './Header.module.scss';
import urlConsts from './../../constants/urls';
import analyticsUtil from './../../utils/segmentUtils'
import { isNull } from 'util';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isConfirmationOpen: false,
            helpScreen: -1
        }
    }

    toggleHelpMenu = (e) => {
        e.stopPropagation();
        if (this.props.uiState.gameState.isHelpMenuOpen) {
            this.props.closeHelpMenu()
        } else {
            this.props.openHelpMenu()
        }
    }

    setHelpScreen = (id) => {
        this.setState({
            helpScreen: id
        })
    }

    closeHelpScreen = () => {
        this.setState({
            helpScreen: -1
        });
    }

    openConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: true
        })
    }

    closeConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: false
        })
    }

    logout = () => {
        let logoutUrl = (this.props.logoutType === 'NORMAL') ? urlConsts.LOGOUT_URL : urlConsts.RETURN_URL
        analyticsUtil.reset()
        window.location = logoutUrl
    }

    render() {
        let { isConfirmationOpen, helpScreen } = this.state;
        let isTutorial = window.location.href.includes('tutorial');

        let logoutButtonText = (this.props.logoutType === 'NORMAL') ? getLabel('label_logout_button') : getLabel('label_return_button');
        let logoutConfirmation = (this.props.logoutType === 'NORMAL') ? getLabel('label_logout_confirmation') : getLabel('label_return_confirmation');

        return (
            <Fragment>
                <header className={styles['header-container']} style={{ backgroundImage: `url(${headerImage})` }}>
                    <div className={styles['header-wrapper']}>
                        <div className={styles.title}>
                            <SimLogo />
                        </div>
                        <Timer timeLeft={this.props.timeData.timeLeft} />
                        <div className={styles['right-content-container']}>
                            <p
                                className={styles.helper}
                                onClick={this.toggleHelpMenu}
                                id="tutorial-help"
                            >
                                {/* <img src={helpIcon} /> */}
                                {getLabel('label_header_help_button')}
                                <img src={downArrow} />
                            </p>
                            <p
                                className={styles.logout}
                                onClick={this.openConfirmationBox}
                                style={isTutorial ? { zIndex: 100000 } : {}}
                            >
                                {
                                    (this.props.logoutType === 'NORMAL')
                                        ? getLabel('label_logout_button')
                                        : getLabel('label_return_button')
                                }
                            </p>
                        </div>
                    </div>
                </header>
                {/* <Route
                    path={match.url + '/help/:helpType'}
                    render={(props) => (<HelpContainer
                    />)}
                /> */}
                {
                    isConfirmationOpen ?
                        <Confirmation
                            acceptButtonText={logoutButtonText}
                            confimationMessage={logoutConfirmation}
                            onAcceptClick={this.logout}
                            onCancelClick={this.closeConfirmationBox}
                            isTutorialLogout={true}
                        />
                        :
                        null
                }
                {
                    this.props.uiState.gameState.isHelpMenuOpen ?
                        <HelpMenu onOptionClick={this.setHelpScreen} introductionData={this.props.uiState.introductionData} />
                        :
                        null
                }
                {
                    helpScreen > 0 ?
                        <HelpContainer
                            screenId={helpScreen}
                            closeHelpScreen={this.closeHelpScreen}
                            actors={this.props.actors}
                            selfActor={this.props.uiState.selfActor}
                            orgChart={this.props.uiState.orgChart}
                            introductionData={this.props.uiState.introductionData}
                        />
                        :
                        null
                }
            </Fragment>
        )
    }
}

Header.propTypes = {
    timeData: PropTypes.object
};

Header.defaultProps = {
    timeData: {}
}

export default Header;


// WEBPACK FOOTER //
// /src/components/header/Header.js